
import { register } from '@shopify/theme-sections'
import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/section-icon-carousel.scss'

export default register(`section-icon-carousel`, {
  onLoad() {
      $(`.icon-carousel-slider`).slick({
          "autoplay": false,
          "slidesToShow": 8,
          "slidesToScroll": 2,
          "arrows": false,
          "dots": false,
          "responsive": [
              {
                  "breakpoint": 2000,
                  "settings": {
                      "autoplay": false,
                      "slidesToShow": 8,
                      "arrows": false,
                      "dots": false
                  }
              },
              {
                  "breakpoint": 1750,
                  "settings": {
                      "autoplay": false,
                      "slidesToShow": 7,
                      "arrows": false,
                      "dots": false
                  }
              },
              {
                  "breakpoint": 1600,
                  "settings": {
                      "autoplay": false,
                      "slidesToShow": 6,
                      "arrows": false,
                      "dots": false
                  }
              },
              {
                  "breakpoint": 1300,
                  "settings": {
                      "autoplay": false,
                      "slidesToShow": 5,
                      "arrows": false,
                      "dots": false
                  }
              },
              {
                  "breakpoint": 1100,
                  "settings": {
                      "autoplay": false,
                      "slidesToShow": 4,
                      "arrows": false,
                      "dots": false
                  }
              },
              {
                  "breakpoint": 868,
                  "settings": {
                      "autoplay": false,
                      "slidesToShow": 2,
                      "arrows": false,
                      "dots": false
                  }
              }
          ]
      })
  },

  onUnload() {
      
  },
})